import { DialogComponent } from '@theme/dialog';
import { kampagneLive } from '@theme/lhc-aktion';

/**
 * Aktions-Pop-up: öffnet sich im Kampagnenfenster nach einer Verzögerung einmal pro Besucher.
 * Der Merk-Schlüssel (data-key) trennt Kampagnen; ein neuer Schlüssel zeigt das Pop-up wieder.
 *
 * @extends DialogComponent
 */
class AktionPopup extends DialogComponent {
  #timer = null;

  get #storageKey() {
    return `lhc:aktion-popup:${this.dataset.key || 'kampagne'}`;
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.hasAttribute('data-design-mode')) {
      document.addEventListener('shopify:section:select', this.#onSelect);
      document.addEventListener('shopify:section:deselect', this.#onDeselect);
      return;
    }

    if (!kampagneLive(this) || this.#seen()) return;
    this.#timer = setTimeout(this.#openWhenIdle, Number(this.dataset.delay ?? 4) * 1000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearTimeout(this.#timer);
    document.removeEventListener('shopify:section:select', this.#onSelect);
    document.removeEventListener('shopify:section:deselect', this.#onDeselect);
  }

  #openWhenIdle = () => {
    if (this.refs.dialog.open || !kampagneLive(this)) return;
    const otherOpen = [...document.querySelectorAll('dialog[open]')].some((el) => el !== this.refs.dialog);
    if (otherOpen || document.visibilityState !== 'visible') {
      this.#timer = setTimeout(this.#openWhenIdle, 2000);
      return;
    }
    this.#remember();
    this.showDialog();
  };

  #seen() {
    try {
      return localStorage.getItem(this.#storageKey) !== null;
    } catch {
      return false;
    }
  }

  #remember() {
    try {
      localStorage.setItem(this.#storageKey, String(Date.now()));
    } catch {}
  }

  #onSelect = (event) => {
    if (event.detail?.sectionId === this.dataset.sectionId) this.showDialog();
  };

  #onDeselect = (event) => {
    if (event.detail?.sectionId === this.dataset.sectionId) this.closeDialog();
  };
}

if (!customElements.get('lhc-aktion-popup')) customElements.define('lhc-aktion-popup', AktionPopup);
